// Human location line for a physical copy without repeating itself.
// "Nathan's Pitch Black · Nathan's Pitch Black page 4 · pocket 7" becomes
// "Nathan's Pitch Black · page 4 · pocket 7".
export function whereLine(e, t) {
  if (!e) return '';
  const loc = (e.location_name || '').trim();
  let page = (e.compartment_label || '').trim();
  if (!page && e.page) page = t ? t('companion.page', { n: e.page }) : `page ${e.page}`;
  if (loc && page) {
    const l = loc.toLowerCase();
    const p = page.toLowerCase();
    if (p.startsWith(l)) page = page.slice(loc.length).replace(/^[\s·:,-]+/, '').trim();
    if (p === l) page = '';
  }
  const slot = e.slot != null ? e.slot : (typeof e.position === 'number' && e.position >= 1000 ? Math.floor(e.position / 1000) : null);
  const pocket = slot ? (t ? t('companion.pocket', { n: slot }) : `pocket ${slot}`) : '';
  return [loc, page, pocket].filter(Boolean).join(' · ');
}
